// SPDX-License-Identifier: LicenseRef-Proprietary

import React from 'react';
import './styles/charts/charts.css';
import './styles/vaccine-demo.css';
import { ModelInputsCardConnected } from './components/ModelInputsCardConnected';
import { RegionalCoverageCardConnected } from './components/RegionalCoverageCardConnected';
import { VaccineDashboardKPIsConnected } from './components/VaccineDashboardKPIsConnected';
import { TabPanelConnected } from './components/TabPanelConnected';
import { useAutoBackendComputation } from '../../hooks/useAutoBackendComputation';
import { BackendComputationIndicator } from './components/BackendComputationIndicator';
import { ValidationBanner } from './components/ValidationBanner';
import { useVaccineDashboardStore } from '../../store/vaccineDashboardStore';

/**
 * Presentational view component - pure composition with no prop drilling
 * All state management is handled by connected components via Zustand store
 * Automatically triggers backend computation when inputs or tree change
 */
const VaccineDashboardView: React.FC = () => {
  useAutoBackendComputation(1500);
  const validationResults = useVaccineDashboardStore((state) => state.validationResults);

  return (
    <div className="vaccine-demo">
      <main className="vaccine-demo__main">
        {/* Validation Banner - shows at top when issues detected, spans full width */}
        <div style={{ gridColumn: '1 / -1' }}>
          <ValidationBanner validation={validationResults} />
        </div>
        <section style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <ModelInputsCardConnected />
          <RegionalCoverageCardConnected />
        </section>

        <section style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <VaccineDashboardKPIsConnected />
          <TabPanelConnected />
        </section>
      </main>

      <footer style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 16px 40px' }}>
        <div style={{ fontSize: '12px', color: 'var(--vaccine-text-secondary)' }}>
          Vaccine value analysis for Finland
        </div>
        <div style={{ fontSize: '11px', color: 'var(--vaccine-text-tertiary)', marginTop: '4px', fontStyle: 'italic' }}>
          Results are conditional on the user-defined inputs.
        </div>
      </footer>

      <BackendComputationIndicator />
      
    </div>
  );
};

export default VaccineDashboardView;

